module.exports = __webpack_public_path__ + "r-v3/img/download_white.dc1ec292.svg";